import script from "./icon-email.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-email.vue?vue&type=script&lang=ts&setup=true"

import "./icon-email.vue?vue&type=style&index=0&id=dc4c0084&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc4c0084"]])

export default __exports__